import React from "react";
import { 
  FaFilePdf, 
  FaFileImage, 
  FaFileAlt, 
  FaFileVideo, 
  FaFileAudio, 
  FaFileCsv, 
  FaFileExcel, 
  FaFileWord, 
  FaFileArchive,
  FaFile
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const FileIcon = ({ extension, className = "w-8 h-8" }) => {
  const ext = extension?.toLowerCase().replace(".", "");

  const getIcon = () => {
    switch (ext) {
      case "pdf":
        return <FaFilePdf className={`${className} text-red-500`} />;
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "svg":
        return <FaFileImage className={`${className} text-blue-500`} />;
      case "mp4":
      case "mov":
      case "avi":
        return <FaFileVideo className={`${className} text-purple-500`} />;
      case "mp3":
      case "wav":
        return <FaFileAudio className={`${className} text-pink-500`} />;
      case "csv":
        return <FaFileCsv className={`${className} text-green-600`} />;
      case "xlsx":
      case "xls":
        return <FaFileExcel className={`${className} text-green-700`} />;
      case "doc":
      case "docx":
        return <FaFileWord className={`${className} text-blue-700`} />;
      case "zip":
      case "rar":
      case "7z":
        return <FaFileArchive className={`${className} text-yellow-600`} />;
      case "txt":
        return <FaFileAlt className={`${className} text-gray-500`} />;
      default:
        return <FaFile className={`${className} text-slate-400`} />;
    }
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={ext}
        initial={{ opacity: 0, scale: 0.5, y: 10, rotate: -15 }}
        animate={{ opacity: 1, scale: 1, y: 0, rotate: 0 }}
        exit={{ opacity: 0, scale: 1.5, y: -10, rotate: 15 }}
        transition={{ 
          type: "spring",
          stiffness: 300,
          damping: 20,
          mass: 1
        }}
        className="flex items-center justify-center"
      >
        {getIcon()}
      </motion.div>
    </AnimatePresence>
  );
};

export default FileIcon;
